import { Component, Input } from "@angular/core"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"

@Component({
    selector: "app-agreement-modal",
    templateUrl: "./agreement-modal.component.html",
    styleUrls: ["./agreement-modal.component.less"],
})
export class AgreementModalComponent {
    @Input() public downloadUrl: string

    constructor(public activeModal: NgbActiveModal) {}
}
